import React from "react";

export default class HowNearMe extends React.Component 
{
    constructor(props)
    {
        super(props);

        if(!this.props.hide)
        {   
            this.requestImageFile = require.context('../images/icons/kpp', true);
            
            this.hows = [
            {
                text: props.code === "demolition" ? 'Describe your project and get matched to local pros.' : 'Describe what you need and get matched to local pros.',
                image:
                {
                    alt: 'contractors',
                    path: props.code === "demolition" ? './how-hometown-works-icon-1.png' : './how-hometown-works-icon-1.png'  // demolition: './contractors.png'
                }
            },
            {
                text: props.code === "demolition" ? 'Get project estimates from qualified companies.' : 'Get quotes from top-rated companies.',
                image:
                {
                    alt: 'contractor',
                    path: props.code === "demolition" ? './how-hometown-works-icon-2.png' : './how-hometown-works-icon-2.png' // demolition: './contractor.png'
                }
            },
            {
                text: props.code === "demolition" ? "Compare quotes and hire the right pro for the job." : 'Compare quotes and hire the right pro for the job.',
                image:
                {
                    alt: 'star contractor',
                    path: props.code === "demolition" ? './how-hometown-works-icon-3.png' : './how-hometown-works-icon-3.png' // demolition: './star.png'
                }
            }
            ]
        }            
    }
    
    render() 
    {    
        if(this.props.hide)
        {
            return( <></> )
        }
        
        return (
            <div className={this.props.page != 'home' ? "container-fuild how-demolition nearmeHowContainer" : "container-fuild how-demolition nearmeHowContainerHome"}>   
                <div class="container"> 
                    <div className="row m-0">  
                        <h2>How Hometown Works</h2>            
                        <div className="hows">
                            <div className="row">
                            {
                                this.hows.map((how, index) =>
                                {                                                 
                                    return(
                                        <div className="col-lg-4">
                                            <div className="how nearmeHow">
                                                <div className={index != (this.hows.length -1) ? "image" : "image lastIcon"}>
                                                    <img src={this.requestImageFile(how.image.path)?.default} alt={how.image.alt} />
                                                    {(index === 0 || index === 1) && <hr className="dottedLine"/>}
                                                </div>
                                                <div className="text">
                                                    <p>{how.text}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};